export const styles = () => ({
  paperRoot: {
    width: '100%',
    borderRadius: 20,
    boxShadow: '0px 5px 30px rgba(45, 51, 59, 0.15)',
  },
});
